import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import {TreeView} from "@material-ui/lab";
import {Typography} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router";
import SideBarTree from "../../../../SideBarNew/SideBarTree";
import {setClearProps, setFocus, setUpdateData} from "../../../../../app/app.slice";
import request from "../../../../../Services/API/Requests";
import {Loading} from "../../../../../Utils/Loading/Loading";
import SearchBar from "../../../../SideBarNew/SearchBar";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import getParamsFromString from "../../../Utils/getParamsFromString";
import HorizontalMenu from "./HorizontalMenu";
import FooterMenu from "./FooterMenu";
import {getUserFromStorage} from "../../../jsonScreen.slice";
import clsx from "clsx";

const Menu = (props) => {
    const {
        component, doActions, screenName,
        actionsContext: {
            doc: {isOpenDrawer, closedCompact} = {}
        } = {}
    } = props;
    const {
        properties: {
            mode,
            menu: menuId,
            enableSearch,
        } = {},
        styles: sourceStyles = [{}]
    } = component;
    const {inFocus} = useSelector(state => state.app);
    const {globalValues} = useSelector(state => state.jsonScreen);
    const [menu, setMenu] = useState([]);
    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState('')
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();

    const [menuStyles, dropdownItemStyles] = sourceStyles;
    useEffect(() => {
        try {
            async function getMenu() {
                try {
                    setLoading(true);
                    let userMenu = {main: []}
                    const storage = getUserFromStorage();
                    const currentMenu = menuId ? menuId : storage && storage.user ? storage.user.menu : ''

                    if (typeof currentMenu === 'string') {
                        userMenu = await request({
                            url: "/menu/read", data: {id: currentMenu}
                        });
                    } else if (Array.isArray(currentMenu) && currentMenu.length) {
                        userMenu = {
                            main: currentMenu.length > 1 ? currentMenu.map(menu => {
                                return {
                                    properties: {
                                        label: menu.multiRoleSettings?.label || menu.name ,
                                        icon: menu.multiRoleSettings?.icon,
                                        iconType: menu.multiRoleSettings?.iconType,
                                    },
                                    sub: menu.main,
                                }
                            }) : currentMenu[0].main
                        }
                    }
                    const options = createOptions(userMenu.main);
                    setOptions(options)
                    setMenu(userMenu.main);
                    setLoading(false)
                } catch (e) {
                    console.log('get menu error', e)
                    setLoading(false)
                }
            }

            getMenu();
        } catch (e) {
            setLoading(false);
            console.log(e)
        }
    }, [menuId]);
    useEffect(() => {
        //only for vertical mode menu or !mode, by default its vertical
        if (mode === 'vertical' || !mode) {
            controlFocus()
        }

    }, [inFocus, selected, mode])

    function onKeyDownItem(e, itemURL) {
        if (e.key === 'Enter') {
            onMenuItemSelect(itemURL)
        }
    }

    function controlFocus() {
        if (inFocus === 'sidebar') {
            const node = document.getElementById(`sidebar_${selected ? selected : 0}`);
            node && node.focus();
        }
    }

    function onMenuItemSelect(nodeId) {
        const menuItem = findByString(menu, `${nodeId}`) || {properties: {}};
        const {url, anchor} = menuItem.properties || {};
        const executedUrl = getParamsFromString(url, globalValues, screenName)
        const actions = findActions(menuItem, executedUrl, anchor);
        const isSameUrl = location.pathname === url;

        //clear lists state from storage
        sessionStorage.removeItem("listsState");

        if (actions) {
            doActions(actions, {clearStack: true})
        }

        if (!url && !anchor) {
            setSelected(nodeId)
            return;
        }


        if (isSameUrl) {
            dispatch(setUpdateData(true));
            dispatch(setFocus('content'));
            setSelected(nodeId)
            return;
        }

        setSelected(nodeId)

        dispatch(setClearProps(true));
        dispatch(setFocus('content'))
    }

    function createOptions(items) {
        let options = [];

        function flatMenu(items) {
            for (let item of items) {
                if (item.sub) {
                    flatMenu(item.sub)
                }
                if (item.properties && item.properties.url) {
                    options.push({
                        label: item.properties.label,
                        icon: item.properties.icon,
                        url: item.properties.url
                    })
                }
            }
        }

        flatMenu(items)
        return options;
    }

    if (loading) return <div style={{
        width: '100%'
    }}>
        <Loading/>
    </div>
    return (
        <>
            {enableSearch && (
                <div
                    className={'sb-menu-searchbar-container'}
                    style={{width: '100%', display: 'flex', justifyContent: 'center', paddingBottom: 10}}>
                    <SearchBar
                        defaultValue={' '}
                        options={options}
                    />
                </div>)}
            {menu && menu.length ? (
                mode === 'horizontal' ? (
                    <HorizontalMenu
                        menuStyles={menuStyles}
                        menu={menu}
                        onClick={onMenuItemSelect}
                        screenName={screenName}
                        dropdownItemStyles={dropdownItemStyles}
                        doActions={doActions}
                    />
                ) : mode === 'footerMenu' ? (
                    <FooterMenu
                        menu={menu}
                        onClick={onMenuItemSelect}
                        screenName={screenName}
                        dropdownItemStyles={dropdownItemStyles}
                    />
                ) : (
                    <TreeView
                        // className={classes.treeViewRoot}
                        className={clsx(menuStyles.listClassName, "sb-menu-ul-container")}
                        selected={selected}
                        onNodeSelect={(e, nodeId) => onMenuItemSelect(nodeId)}
                        defaultCollapseIcon={<ArrowDropDownIcon/>}
                        defaultExpandIcon={<ArrowRightIcon/>}
                        defaultEndIcon={<div style={{width: 24}}/>}
                    >
                        {SideBarTree({
                            menu, onKeyDownItem,
                            screenName,
                            dropdownItemStyles,
                            menuStyles,
                            doActions,
                            closedCompact,
                            isOpenDrawer
                        })}
                    </TreeView>
                )
            ) : (<NoMenuComponent/>)}
        </>
    )
}
export default JsonScreenHoc(Menu);

Menu.propTypes = {
    component: PropTypes.object,
    doActions: PropTypes.func
}
Menu.defaultProps = {
    component: {}
}

const NoMenuComponent = () => {
    return <div
        style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Typography color={"textSecondary"}>
            No Menu
        </Typography>
    </div>
}

/**
 *
 * @param menuItem
 * @param url
 * @param anchor
 * @returns {*[]|*}
 */
export function findActions(menuItem, url, anchor) {
    const nextScreenAction = url ? [{type: 'nextScreen', destination: url, anchor}] : [];
    if (menuItem.events && menuItem.events.length) {
        const onClickIndex = menuItem.events.findIndex(o => o.event === 'onClick');
        if (onClickIndex !== -1) {
            const actions = menuItem.events[onClickIndex].actions || [];
            return [...nextScreenAction, ...actions];
        }
    }
    return nextScreenAction;
}
